import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";
import {gsap} from "../../lib/gsap";

export default class NavsFull {
    static init() {
        this.header = document.querySelector(".header-main-full");

        if (this.header) {
            this.overlay = this.header.querySelector(".overlay");
            this.navBg = this.header.querySelector(".nav-main-bg");
            this.toggleMobileNav();
            this.initMegaMenu();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeMobileNav();
                } else {
                    this.openMobileNav();
                }
            });
        }
    }

    static openMobileNav() {
        document.body.classList.add("navs-open");
        Header.makeHeaderAsBannerTheme();

        if (typeof GlobalVariables.smoother !== "undefined") {
            GlobalVariables.smoother.paused(true);
        }
    }

    static closeMobileNav() {
        document.body.classList.remove("navs-open");
        Header.restoreHeaderTheme();

        const activeMenuItems = this.header.querySelectorAll(".menu-item-lev1.active");
        activeMenuItems.forEach(item => {
            item.classList.remove("active");
            const subnav = item.querySelector(".lev2");
            subnav.classList.remove("show");
        });

        if (typeof GlobalVariables.smoother !== "undefined") {
            GlobalVariables.smoother.paused(false);
        }
    }

    static initMegaMenu() {
        // Un clic sur l'overlay ferme tout
        this.overlay.addEventListener("click", () => {
            this.closeAllLev2();
        });

        this.navMain = this.header.querySelector(".nav-main");
        this.levelOneItems = this.navMain.querySelectorAll(".menu-item-lev1.menu-item-has-children");

        this.levelOneItems.forEach(levelOne => {
            levelOne.toggle = levelOne.querySelector("button[data-header='toggler']");
            levelOne.levelTwo = levelOne.querySelector(".lev2-items");

            if (!levelOne.levelTwo) {
                return;
            }

            levelOne.toggle.addEventListener("click", (e) => {
                e.preventDefault();

                if (levelOne.classList.contains("active")) {
                    Header.restoreHeaderTheme();

                    this.navMain.classList.remove("subnav-active");
                    this.adjustNavBg(levelOne.levelTwo);
                    levelOne.classList.remove("active");
                    levelOne.levelTwo.classList.remove("show");
                    levelOne.toggle.setAttribute("aria-expanded", false);

                    if (window.innerWidth > 991 && typeof GlobalVariables.smoother !== "undefined") {
                        GlobalVariables.smoother.paused(false);
                    }
                } else {
                    this.closeAllLev2();

                    Header.makeHeaderAsBannerTheme();
                    this.navMain.classList.add("subnav-active");
                    this.adjustNavBg(levelOne.levelTwo);
                    levelOne.classList.add("active");
                    levelOne.levelTwo.classList.add("show");
                    levelOne.toggle.setAttribute("aria-expanded", true);

                    if (window.innerWidth > 991 && typeof GlobalVariables.smoother !== "undefined") {
                        GlobalVariables.smoother.paused(true);
                    }
                }
            });
        });
    }

    static closeAllLev2() {
        Header.restoreHeaderTheme();
        this.navMain.classList.remove("subnav-active");
        this.levelOneItems.forEach(item => {
            item.classList.remove("active");
            item.levelTwo.classList.remove("show");
            item.querySelector("button[data-header='toggler']").setAttribute("aria-expanded", "false");
        });

        if (window.innerWidth > 991 && typeof GlobalVariables.smoother !== "undefined") {
            GlobalVariables.smoother.paused(false);
        }
    }

    static restoreNav() {
        this.closeAllLev2();
        this.closeMobileNav();
    }

    static adjustNavBg(levelTwo) {
        if (window.innerWidth > 991) {
            const navBg = this.header.querySelector(".nav-main .nav-main-bg");
            gsap.to(navBg, {duration: 0.3, height: levelTwo.offsetHeight});
        }
    }

    static resize() {
        this.restoreNav();
    }
}